import { UserRoles } from '@shared/model/user';
import { TabValues } from '../../config/ui-constants';
import { SegmentTab } from '@shared/ui/segment-tabs/types';

export const tabs = (
    {
        catalogCount,
        reviewCount,
        completedCount,
    }: {
        catalogCount: number | undefined;
        reviewCount: number | undefined;
        completedCount: number | undefined;
    },
    userRole?: string
): SegmentTab[] => {
    const catalogTab: SegmentTab = {
        title: 'Каталог',
        value: TabValues.Catalog,
    };
    const reviewTab: SegmentTab = {
        title: 'На рассмотрении',
        value: TabValues.Review,
    };
    const completedCountTab: SegmentTab = {
        title: 'Приобретенные',
        value: TabValues.Completed,
    };

    if (catalogCount) {
        catalogTab.badge = {
            text: String(catalogCount),
        };
    }

    if (reviewCount) {
        reviewTab.badge = {
            text: String(reviewCount),
        };
    }

    if (completedCount) {
        completedCountTab.badge = {
            text: String(completedCount),
        };
    }

    if (userRole === UserRoles.Employee) {
        return [catalogTab, completedCountTab];
    }

    return [catalogTab, reviewTab, completedCountTab];
};
